import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import { FormGroup, Col, Label, Input, Row, Button, Spinner } from "reactstrap";
//import DropdownList from 'react-widgets/lib/DropdownList'
//import 'react-widgets/dist/css/react-widgets.css'

import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'

import { Table } from "reactstrap";

const mapStateToProps = (state) => {

    return {
        getGCDetail: state.GastoCorrienteReducer.getGCDetail,
    };

}; //END MAPSTATETOPROPS

class GCDelete extends Component {

    render() {
        let isEmpty = this.props.getGCDetail.length === 0;
        let gast = Object.values(this.props.getGCDetail);

        return (
            <form onSubmit={this.props.handleSubmit}>
                <FormGroup row>
                    <Col md="12">
                        <FormGroup>

                            <Table striped>
                                <tbody>


                                    {isEmpty ?
                                        <div>There are no results</div>
                                        :
                                        gast.map(item =>

                                            <>

                                                <tr>
                                                    <td width="200">ID</td>
                                                    <td width="10">:</td>
                                                    <td>{item.idcosto}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Concepto</td>
                                                    <td width="10">:</td>
                                                    <td>{item.nombre}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Monto</td>
                                                    <td width="10">:</td>
                                                    <td>{item.monto}</td>
                                                </tr>





                                            </>

                                        )
                                    }

                                </tbody>
                            </Table>


                        </FormGroup>
                    </Col>
                </FormGroup>


                <FormGroup row>
                    <Col md="12">
                        <FormGroup>
                            {
                                !this.props.submitSucceeded ? (
                                    <Button
                                        color="dark"
                                        type="submit"
                                        disabled={this.props.submitSucceeded}

                                    >
                                        Enviar
                                    </Button>
                                ) : (
                                        <Button variant="success" disabled>
                                            <Spinner
                                                as="span"
                                                animation="grow"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                variant="success"
                                                role="status"
                                            />
                                            Procesando solicitud...
                                        </Button>

                                    )

                            }

                        </FormGroup>
                    </Col>
                </FormGroup>

            </form>
        );
    }

}

GCDelete = reduxForm({
    form: "formGCDelete",
    enableReinitialize: true,
})(GCDelete);
export default connect(mapStateToProps, null)(GCDelete);
